function detectBrowserName() {
    const nav = window.navigator, ua = window.navigator.userAgent.toLowerCase();
    if (-1 !== nav.appName.toLowerCase().indexOf('microsoft') || null !== nav.appName.toLowerCase().match(/trident/gi)) return 'IE';
    if (null !== ua.match(/chrome/gi)) return 'Chrome';
    if (null !== ua.match(/firefox/gi)) return 'Firefox';
    if (null !== ua.match(/safari/gi)) return 'Safari';
    if (null !== ua.match(/webkit/gi)) return 'Webkit';
    if (null !== ua.match(/gecko/gi)) return 'Gecko';
    if (null !== ua.match(/opera/gi)) return 'Opera';
    if (null !== ua.match(/ui-prober/gi)) return 'Prober';
    return 'unknown';
}
export { detectBrowserName };

//# sourceMappingURL=browser.js.map